.group {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.errorMessage {
	color: var(--content-error);
	/* Reserved so the group doesn't shift when the message appears */
	min-height: 15.5px;
}
